// extracted by mini-css-extract-plugin
export default {"whyChooseUsCard":"styles_whyChooseUsCard__-AFZj","whyChooseUsCard__statement":"styles_whyChooseUsCard__statement__7JN+b"};